import "../../styles/InProgressCoursesSection.scss";
import { isSignedIn } from "../../utils/util";
import InProgressCoursesSectionCard from "./InProgressCoursesSectionCard";
import useFetchUserEnrollments from "../../Hooks/useFetchUserEnrollments";
import InProgressCoursesSectionBanner from "./InProgressCoursesSectionBanner";

const InProgressCoursesSection = () => {
	const { userInProgressEnrollments } = useFetchUserEnrollments();

	return (
		<>
			{isSignedIn() && userInProgressEnrollments.length > 0 && (
				<>
					<InProgressCoursesSectionBanner />
					<div className="inprogress-courses-section">
						<div className="inprogress-courses-list-home">
							{userInProgressEnrollments.slice(0, 3).map((item) => (
								<InProgressCoursesSectionCard item={item} />
							))}
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default InProgressCoursesSection;
